import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Breadcrumb } from 'semantic-ui-react'
import { Link } from "react-router-dom";
import './Breadcrumb.scss';

const BreadcrumbExample = ({ url, ...props }) => {
    const state = useSelector((state) => state.veritas.breadcrumb);
    const [links, setLinks] = useState([]);

    useEffect(() => {
        let _links = [];
        if(state.parent && state.parent.url) {
            _links.push(state.parent);
        }
        if(state.list && state.list.url) {
            _links.push(state.list);
        }
        if(state.service && state.service.url) {
            _links.push(state.service);
        }
        if(state.source && state.source.url) {
            _links.push(state.source);
        }
        setLinks(_links);
    }, [state]);

    
    return (
        <Breadcrumb className="breadcrumb">
            {links && links.length > 0 ?
                links.map((item, key, arr) => {
                    return (
                        arr.length - 1 !== key ?
                            <React.Fragment key={key}>
                                <Breadcrumb.Section key={key}>
                                    <Link to={item.url}> {item.text} </Link>
                                </Breadcrumb.Section>
                                <Breadcrumb.Divider icon='right chevron' />
                            </React.Fragment>
                            :
                            <React.Fragment key={key}>
                                <Breadcrumb.Section active key={key}> {item.text} </Breadcrumb.Section>
                            </React.Fragment>
                    )
                })
                : <> </>
            }
        </Breadcrumb>
    )
}

export default BreadcrumbExample
